module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_facturation_remoteEntry_mjs_1ce17b2e__;